<template>
    <div>
        <div class="loader-container" v-if="!loaded">
            <div class="loader"></div>
        </div>
        <b-list-group v-if="loaded">
            <b-list-group-item v-if="!lista_pazienti.length" variant="secondary"><span>Non ci sono pazienti da visualizzare.</span></b-list-group-item>
            <b-list-group-item button class="list-item" v-for="paziente in lista_pazienti" :key="paziente.uid">
                <div class="d-flex justify-content-between align-items-center link" @click="submit(paziente)">
                    <span> {{paziente.cognome + " " + paziente.nome}}</span>
                    <span v-if="paziente.ultima_certificazione"><small>Ultima Certificazione: </small> {{format_date(paziente.ultima_certificazione)}}</span>
                </div>
            </b-list-group-item>
            <div class="load-more" v-show="!displaySearch">
                <b-overlay
                    :show="loadingMore"
                    rounded
                    opacity="0.4"
                    spinner-small
                    spinner-variant="secondary"
                    class="d-inline-block"
                >
                    <b-button v-show="show_load_more" variant="light" @click="getPazienti()" class="load-more-button">Carica più risultati...</b-button>
                </b-overlay>
                <span v-show="!show_load_more">Non ci sono altri risultati</span>
            </div>
        </b-list-group>
    </div> 
</template>

<script>
import {mixins} from '@/mixins';
export default {
    name: "ListaPazienti",
    props: {
        dottore: String,
    },
    data(){
        return{
            pazienti: [],
            loaded: false,
            load_counter: 0,
            show_load_more: true,
            displaySearch: false,
            emptySearch: false,
            loadingMore: false,
        }
    },
    mixins: [mixins],
    computed: {
        lista_pazienti: function(){
            return this.pazienti;
        }
    },
    mounted(){
        this.getPazienti();
    },
    methods: {
        submit: function(paziente) {
            this.$store.dispatch('selectPaziente', {nome: paziente.nome, cognome: paziente.cognome});
            this.$router.push('/paziente/' + paziente.uid)
        },
        getPazienti(){
            this.loadingMore = true;
            if (this.emptySearch && this.load_counter==0){
                this.pazienti = [];
                this.load_counter = 0;
                this.show_load_more = true;
                this.loaded = false;
                this.displaySearch = false;
            }
            if(!this.dottore){
                this.$axios
                .get(this.$apibase + '/api/pazienti/paziente/get_pazienti_admin', {
                    headers: {
                        Authorization:"JWT " + localStorage.getItem('access_token')
                    },
                    params: {
                        counter: this.load_counter
                    }
                })
                .then(response => {
                    this.pazienti = this.pazienti.concat(response.data);
                    this.load_counter++;
                    if(response.data.length == 0){
                        this.show_load_more = false;
                    }
                    this.loadingMore = false;
                    this.loaded = true;
                    })
                .catch((e)=>{
                    if (e.response.status == 403)
                        this.logout();
                    else
                        console.log(e);
                })
            }
            else if(this.dottore){
                this.$axios
                .get(this.$apibase + '/api/pazienti/inCura/get_pazienti_by_dottore/', 
                    {
                    headers: {
                        Authorization:"JWT " + localStorage.getItem('access_token')
                    },
                    params: {
                        dottore: this.dottore,
                        counter: this.load_counter
                    }
                })
                .then(response => {
                    this.pazienti = this.pazienti.concat(response.data);
                    this.load_counter++;
                    if(response.data.length == 0){
                        this.show_load_more = false;
                    }
                    this.loadingMore = false;
                    this.loaded = true;
                })
                .catch((e)=>{
                    if (e.response.status == 403)
                        this.logout();
                    if (e.response.status == 404)
                        return;
                    else
                        alert(e.response);
                })
            }
        }
    }
}
</script>

<style scoped>
    .list-item{
        padding-left: 40px;
        padding-right: 40px;
    }
    .link{
        color: #707070;
    }
    .load-more{
        padding-top: 30px;
    }
    .load-more-button{
        color: #707070;
    }
</style>